const LOCAL_ENVIRONMENT_HOST_NAMES = ["localhost", "127.0.0.1"];

export const checkIsLocalEnvironment = (): boolean => {
  const { hostname } = window.location;

  return LOCAL_ENVIRONMENT_HOST_NAMES.includes(hostname);
};
